/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_faq5_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Toolverse is an independent, fan-built analytics platform for the official F1 Fantasy game. It is not affiliated with, endorsed by, or officially connected to Formula 1, the FIA, or the F1 Fantasy game itself — all data is sourced from publicly available results and the official game.`)
};

const es_f1_faq5_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Toolverse es una plataforma de analítica independiente, creada por aficionados, para el juego oficial de F1 Fantasy. No está afiliada, respaldada ni conectada oficialmente con la Fórmula 1, la FIA ni el propio juego de F1 Fantasy — todos los datos proceden de resultados de acceso público y del juego oficial.`)
};

const de_f1_faq5_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Toolverse ist eine unabhängige, von Fans entwickelte Analyseplattform für das offizielle F1-Fantasy-Spiel. Es ist nicht mit der Formel 1, der FIA oder dem F1-Fantasy-Spiel selbst verbunden, wird nicht von ihnen unterstützt und steht in keiner offiziellen Beziehung dazu — alle Daten stammen aus öffentlich zugänglichen Ergebnissen und dem offiziellen Spiel.`)
};

const nl_f1_faq5_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Toolverse is een onafhankelijk, door fans gebouwd analyseplatform voor het officiële F1 Fantasy-spel. Het is niet gelieerd aan, goedgekeurd door of officieel verbonden met Formule 1, de FIA of het F1 Fantasy-spel zelf — alle gegevens zijn afkomstig van openbaar beschikbare resultaten en het officiële spel.`)
};

const fr_f1_faq5_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Toolverse est une plateforme d’analyse indépendante, créée par des passionnés, pour le jeu F1 Fantasy officiel. Elle n’est ni affiliée, ni approuvée, ni officiellement liée à la Formule 1, à la FIA ou au jeu F1 Fantasy lui-même — toutes les données proviennent de résultats accessibles au public et du jeu officiel.`)
};

const it_f1_faq5_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Toolverse è una piattaforma di analisi indipendente, creata da appassionati, per il gioco ufficiale F1 Fantasy. Non è affiliata, sponsorizzata o ufficialmente collegata alla Formula 1, alla FIA o al gioco F1 Fantasy stesso — tutti i dati provengono da risultati pubblicamente disponibili e dal gioco ufficiale.`)
};

const pt_br2_f1_faq5_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A Toolverse é uma plataforma independente de análises, feita por fãs, para o jogo oficial F1 Fantasy. Não é afiliada, endossada ou oficialmente conectada à Fórmula 1, à FIA ou ao próprio jogo F1 Fantasy — todos os dados são obtidos de resultados publicamente disponíveis e do jogo oficial.`)
};

const pt_f1_faq5_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A Toolverse é uma plataforma de análise independente, criada por fãs, para o jogo oficial F1 Fantasy. Não está afiliada, endossada ou oficialmente ligada à Formula 1, à FIA ou ao próprio jogo F1 Fantasy — todos os dados provêm de resultados publicamente disponíveis e do jogo oficial.`)
};

const ja_f1_faq5_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。Toolverseは、公式F1ファンタジーゲームのための、ファンが独自に構築した分析プラットフォームです。Formula 1、FIA、F1ファンタジーゲーム自体のいずれとも提携、推奨、公式な関係はありません — すべてのデータは公開されている結果と公式ゲームから取得しています。`)
};

const zh_f1_faq5_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有。Toolverse 是一个独立的、由车迷打造的官方 F1 Fantasy 游戏分析平台。它与 Formula 1、FIA 或 F1 Fantasy 游戏本身均无隶属、背书或官方关联——所有数据均来自公开的比赛结果和官方游戏。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_faq5_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_faq5_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_faq5_a", locale)
	if (locale === "en") return en_f1_faq5_a(inputs)
	if (locale === "es") return es_f1_faq5_a(inputs)
	if (locale === "de") return de_f1_faq5_a(inputs)
	if (locale === "nl") return nl_f1_faq5_a(inputs)
	if (locale === "fr") return fr_f1_faq5_a(inputs)
	if (locale === "it") return it_f1_faq5_a(inputs)
	if (locale === "pt-BR") return pt_br2_f1_faq5_a(inputs)
	if (locale === "pt") return pt_f1_faq5_a(inputs)
	if (locale === "ja") return ja_f1_faq5_a(inputs)
	return zh_f1_faq5_a(inputs)
};